import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import {
  holiday_list_action,
  holiday_delete_action,
} from "../../../actions/master_actions/holiday_action";
import { fill_action } from "../../../actions/fillList_action";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../../utils/Loader";
import { forwardRef } from "react";
import DatePicker from "react-datepicker";
import moment from "moment";
import { DaysActionId, StatusActionId, sessionExpireMessage, tokenInavlidMessage } from "../../../utils/constants";
import { data } from "jquery";
import Header from "../../../common_components/Header";
import Pagination from "../../../utils/pagination";

const CustomInput = forwardRef(
  ({ value, onClick, onChange, disabled }, ref) => (
    <input
      type="text"
      className="form-control"
      value={value}
      onClick={onClick}
      onChange={onChange}
      disabled={disabled}
      ref={ref}
    />
  )
);

class Holidays extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      isOpen: false,
      daysList: [],
      HolidayID: "",
      userId: "",
      Name: "",
      Date: "",
      Day: "",
      currentPage: 1,
      holidayList: [],
      Status: null,
      statusFillList: [],
      isAccordionExpanded: false,
    };
    this.getHolidayList = this.getHolidayList.bind(this);
    this.updateItem = this.updateItem.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }
  componentDidMount() {
    if (JSON.parse(sessionStorage.getItem("UserLoginData")) == null) {
      console.log("log");
      setTimeout(() => {
        this.props.navigate("/login");
      }, 500);
    }
    setTimeout(() => {
      {
        sessionStorage.getItem("roleId") == 4 ? (
          this.props.navigate("/checkList")
        ) : (
          <></>
        );
      }
    }, 10);
    const { userId } = this.state;
    this.setState({
      userId:
        sessionStorage.getItem("userId") == "" ||
        sessionStorage.getItem("userId") == null
          ? ""
          : sessionStorage.getItem("userId"),
    });
    this.getHolidayList();
    this.getFillList(DaysActionId, userId, "", "");
    this.getFillList(StatusActionId, userId, "", "");
  }
  navigateHolidayAdd() {
    this.props.navigate("/holidays_edit");
  }
  handleUpdateHoliday(HolidayID) {
    console.log(HolidayID);
    this.props.navigate(`/holidays_edit`, {
      state: { HolidayID: HolidayID },
    });
  }
  handleInputSearchChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  getFillList(value, userId, keyword, keyvalue) {
    this.setState({ isLoading: true });
    this.props
      .fill_action(
        value,
        userId == "" || userId == null ? null : userId,
        keyword != "" ? keyword : null,
        keyvalue != "" ? keyvalue : null
      )
      .then((data) => {
        console.log(data, "daysFillList");
        if (data.error != 1) {
          if (value == DaysActionId) {
            this.setState({ daysList: data.data, isLoading: false });
          }
          if (value == StatusActionId) {
            this.setState({ statusFillList: data.data, isLoading: false });
            console.log(data.data, "status");
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
  getHolidayList() {
    const { Name, Date, Day, Status } = this.state;
    this.setState({ isLoading: true });
    const finalDay=Day=="Sunday"?"Sun":Day=="Monday"?"Mon":Day=="Tuesday"?"Tue":Day=="Wednesday"?"Wed":Day=="Thursday"?"Thu":Day=="Friday"?"Fri":Day=="Saturday"?"Sat":""
    const finalStatus = Status == "InActive" ? 0 : Status=="Active"?1:null;
    console.log(finalDay,Day)
    this.props
      .holiday_list_action(Name, Date, finalDay, finalStatus)
      .then((data) => {
   
        if (data.error != 1) {
          data.data.sort((a, b) => a.Date.localeCompare(b.Date));
          const formattedData = data.data.map((item) => ({
            ...item,
            Date: moment(item.Date).format("YYYY-MM-DD"),
          }));

          this.setState({
            holidayList: formattedData,
            isLoading: false,
            currentpage: 1,
          });
        } else {
          if(data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage){
            //after session expire.....................
            sessionStorage.clear()
            this.props.navigate('/normalView')
            setTimeout(() => {
              toast.error(data.msg, {
                position:"top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
        }else{
          toast.error(data.msg, {
            position:"top-center",
            theme: "colored",
            autoClose: 3000,
            hideProgressBar: true,
          });}
        }
      })
      .catch((e) => {
        console.log(e);
      });
   
  }

  handleDelete(holidayID) {
    const confirm = window.confirm(
      "Are you sure you want to delete this Holiday?"
    );
    if (confirm) {
      this.props
        .holiday_delete_action(holidayID)
        .then((data) => {
          if (data.error !== 1) {
            toast.success("Data Deleted Successfully", {
              position:"top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
            this.getHolidayList(); // Refresh the holiday list after deletion
          } else {
            if(data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage){
              //after session expire.....................
              sessionStorage.clear()
              this.props.navigate('/normalView')
              setTimeout(() => {
                toast.error(data.msg, {
                  position:"top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
          }else{
            toast.error(data.msg, {
              position:"top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }}
        })
        .catch((e) => {
          console.log(e);
        });
    } else {
      window.location.reload();
    }
  }
  holidayRecord(holidayList) {
    // const { userList } =this.state
    return (
      <table class="table table-bordered table-striped" id="tbl">
        <thead>
          <tr>
            <th style={{ width: "40%" }}>Holiday</th>
            <th style={{ width: "30%" }}>Date</th>
            <th>Day</th>
            <th>Status</th>
            <th class="text-right" style={{ width: "7.5%" }}>
              Action
            </th>
          </tr>
        </thead>
        <tbody id="myTable">
          {holidayList != "" && holidayList != null ? (
            holidayList.map((item, key) => (
              <tr key={key}>
                <td>{item.Name}</td>
                <td>{moment(item.Date).format("DD-MM-YYYY")}</td>
                <td>{item.Day=="Sun"?"SUNDAY":item.Day=="Mon"?"MONDAY":item.Day=="Tue"?"TUESDAY":item.Day=="Wed"?"WEDNESDAY":item.Day=="Thu"?"THURSDAY":item.Day=="Fri"?"FRIDAY":"SATURDAY"}</td>
                <td>{item.StatusID==1?"Active":"Inactive"}</td>
                <td class="text-right">
                  <a
                    title="Edit"
                    class="btn btn-sm"
                    onClick={() => this.handleUpdateHoliday(item.HolidayID)}
                  >
                    <i class="fa fa-edit action_btn_table" />
                  </a>
                  {item.StatusID==1?(

                    <a
                    title="Delete"
                    className="btn btn-sm delete_record"
                    onClick={() => this.handleDelete(item.HolidayID)}
                    >
                    <i className="fa fa-trash action_btn_table"></i>
                  </a>
                    ):<></>}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8">No data available</td>
            </tr>
          )}
        </tbody>
      </table>
    );
  }
  updateItem(item) {
    this.setState({ currentPage: item });
  }
  render() {
    const {
      isLoading,
      holidayList,
      daysList,
      newHoliday,
      showNewRow,
      Name,
      Date,
      Day,
      currentPage,
      isAccordionExpanded,
      Status,statusFillList
      // isOpen,
      // clientDeleteId,
    } = this.state;
    const recordsPerPage = 10;
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    // Records to be displayed on the current page
    const currentRecords = holidayList.slice(
      indexOfFirstRecord,
      indexOfLastRecord
    );
    const nPages = Math.ceil(holidayList.length / recordsPerPage);

    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <>
          <main id="main">
            <Header data={[15]} />

            <section style={{ marginTop: 115 }}>
              <div class="container-fluid">
                <div class="page-header">
                  <h4 class="page-title">List of Holiday</h4>
                  <div>
                    <a
                      href="javascript:void(0);"
                      onClick={() => this.navigateHolidayAdd()}
                      className="btn btn-primary btn-sm create_btn"
                    >
                      <span className="hidden-xs">Add</span>
                    </a>
                  </div>
                </div>
                <div className="search_accordion search_card">
                  <div className="panel-group" id="accordion">
                    <div className="panel panel-default">
                      <div
                        className="panel-heading accordion-toggle collapsed"
                        data-toggle="collapse"
                        data-parent="#accordion"
                        data-target="#collapseOne"
                        aria-expanded={isAccordionExpanded}
                        onClick={() =>
                          this.setState({
                            isAccordionExpanded: !isAccordionExpanded,
                          })
                        }
                      >
                        <h4 className="panel-title">Search</h4>
                        <div className="searched_items">
                          <h5>
                            Holiday Name: <span>{Name}</span>
                          </h5>
                          <h5>
                            Day: <span>{Day}</span>
                          </h5>
                          <h5>
                            Status:{" "}
                            <span>{Status}</span>
                          </h5>
                        </div>
                      </div>
                      <div
                        id="collapseOne"
                        className={`panel-collapse collapse ${
                          isAccordionExpanded ? "show" : ""
                        }`}
                        aria-labelledby="headingOne"
                      >
                        <div>
                          <div className="panel-body">
                            <div className="row mr_0">
                              <div className="col-md-2">
                                <div className="form-group">
                                  <label>Holiday</label>
                                  <input
                                    type="text"
                                    name="Name"
                                    className="form-control"
                                    value={this.state.Name}
                                    onChange={this.handleInputSearchChange}
                                    placeholder="Holiday Name"
                                  />
                                </div>
                              </div>

                              <div className="col-md-2">
                                <div className="form-group">
                                  <label>Day</label>
                                  <select
                                    className="form-control"
                                    name="Day"
                                    value={Day}
                                    onChange={this.handleInputSearchChange}
                                  >
                                    <option>--Select--</option>
                                    {daysList.length > 0 ? (
                                      daysList.map((data) => (
                                        <option key={data.Day} value={data.Day}>
                                          {data.Day}
                                        </option>
                                      ))
                                    ) : (
                                      <></>
                                    )}
                                  </select>
                                </div>
                              </div>
                              <div className="col-md-2">
                                <div className="form-group">
                                  <label>Status</label>
                                  <select
                                    className="form-control"
                                    value={this.state.Status}
                                    onChange={(e) =>
                                      this.setState({ Status: e.target.value })
                                    }
                                  >
                                    <option value="">Select Status</option>
                                    {statusFillList.length > 0
                                      ? statusFillList.map((data) => (
                                          <option
                                            key={data.Status}
                                            value={data.Status}
                                          >
                                            {data.Status}
                                          </option>
                                        ))
                                      : null}
                                  </select>
                                </div>
                              </div>
                              <div className="col-md-4">
                                <label>&nbsp;</label>
                                <button
                                  onClick={() => this.getHolidayList()}
                                  className="btn btn-primary search_btn"
                                >
                                  Search
                                </button>
                                &nbsp;&nbsp;
                                <button
                                  onClick={() => {
                                    this.setState(
                                      {
                                        Day: "",
                                        Name: "",
                                        Status:""
                                      },
                                      () => this.getHolidayList()
                                    );
                                  }}
                                  className="btn btn-primary search_btn"
                                >
                                  Clear Filters
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="custom_table">
                  <div class="hack1">
                    <div class="hack2">
                      {this.holidayRecord(currentRecords)}
                      {holidayList.length > 0 ? (
                        <Pagination
                          nPages={nPages}
                          currentPage={currentPage}
                          setCurrentPage={this.updateItem}
                        />
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </main>
          <ToastContainer />

          {/* <Modal isOpen={isOpen} onRequestClose={this.toggleModal}>
            <div className="modal-dialog custom_modal_dialog">
              <div
                className="modal-content"
                style={{ borderRadius: "0px", width: "500px" }}
              >
                <div class="modal-header">
                  <h4 class="modal-title modal_title_text">Confirm Delete</h4>
                  <button
                    type="button"
                    class="close pop-close"
                    data-dismiss="modal"
                    onClick={this.toggleModal}
                  >
                    <span aria-hidden="true" class="pop-cancel">
                      &times;
                    </span>
                  </button>
                </div>
                <div class="modal-body">
                  <div class="row">
                    <div class="col-md-12">
                      <h3 class="pop_label">
                        Do you really want to delete this record?
                      </h3>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group text-right mod-fot">
                      <a
                        href="javascript:void(0);"
                        class="btn save_btn del-pop-save"
                        onClick={(e) => this.handleDelete(e, clientDeleteId)}
                      >
                        <i class="fa fa-check"></i>&nbsp; Yes
                      </a>
                      <a
                        href="javascript:void(0);"
                        class="btn cancel_btn del-pop-cancel"
                        data-dismiss="modal"
                        style={{ marginLeft: "5px" }}
                        onClick={this.toggleModal}
                      >
                        <i class="fa fa-times"></i>&nbsp; No
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal> */}
        </>
      </>
    );
  }
}

export default withRouter(
  connect(null, {
    holiday_list_action,
    holiday_delete_action,
    fill_action,
  })(Holidays)
);
